import { BASEURL, loginUrl } from '@/baseData'
import axios from './axios.config'
import qs from 'qs'

export default {
  login: {
    /**
     *
     * @param {Object} query //兼职老师登录用户账号密码
     */
    login (query) {
      return axios.post(
        `${BASEURL}ms-member-service/login`,
        qs.stringify(query)
      )
    },
    mdm (config) {
      return axios.get(`${loginUrl}member/mdm-customer`, config)
    }
  },
  member: {
    /**
     *
     * @param {Object} query //兼职老师登录用户账号密码
     */
    login (query) {
      return axios.get(`${loginUrl}member/login`, query)
    },
    mdm (config) {
      return axios.get(`${loginUrl}member/mdm-customer`, config)
    },
    checkCode (query) {
      return axios.post(`${loginUrl}validate/check-code?${qs.stringify(query)}`)
    },
    sendCode (query) {
      return axios.post(`${loginUrl}validate/send-code?${qs.stringify(query)}`)
    }
  },
  fromTest: {
    /**
     * 表单提交测试
     * @param {object} query
     * @param {object} params
     * @return {object} promise
     */
    one (query, params) {
      return axios.post(
        `${BASEURL}special/p/?${qs.stringify(query)}`,
        qs.stringify(params),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      )
    }
  },
  oneOnOne: {
    online (query, params) {
      return axios.post(
        `${BASEURL}special/p/?${qs.stringify(query)}`,
        qs.stringify(params),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      )
    },
    offline (query, params) {
      return axios.post(
        `${BASEURL}special/p/?${qs.stringify(query)}`,
        qs.stringify(params),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      )
    }
  },
  zhongkao: {
    zhongkao (query, params) {
      return axios.get(`${BASEURL}special/p/zksjfx/api/configapi`, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
    }
  },
  site: {
    getNode () {
      // https://m.mingshiedu.com/apis/network/
      return axios.get(`${loginUrl}sites/1/nodes`, {
        params: { code: 'curriculumCatalog' }
      })
    },
    getNodeDetail (id) {
      // https://m.mingshiedu.com/apis/network/
      return axios.get(`${loginUrl}sites/1/nodes/${id}/infos`)
    },
    getInfo (id) {
      // https://m.mingshiedu.com/apis/network/
      return axios.get(`${loginUrl}infos/${id}`)
    },
    getSwiper (location, id) {
      if (id === undefined) {
        return axios.get(`${loginUrl}rotationImg/M/${location}`)
      }
      return axios.get(`${loginUrl}rotationImg/M/${location}?gradeId=${id}`)
    },
    getfindListByLevel () {
      return axios.get(`${loginUrl}sites/findListByLevel`, {
        params: { level: 3 }
      })
    }
  },
  validate: {
    checkCode (query) {
      return axios.post(`${BASEURL}apis/network/validate/check-code?${qs.stringify(query)}`)
    },
    sendCode (query) {
      return axios.post(`${BASEURL}apis/network/validate/send-code?${qs.stringify(query)}`)
    }
  },
  activity: {
    enablePage (query) { // 获取活动信息  m端开启的活动分页
      return axios.get(`${BASEURL}apis/network/activity/enablePage?${qs.stringify(query)}`)
    },
    activityDetail (activityId, query) { // 根据手机和姓名查询活动结果
      return axios.post(`${BASEURL}apis/network/activity/${activityId}/data`,
        qs.stringify(query)
      )
    }
  },
  wechat: {
    jsSdkConfig (config) {
      return axios.get(`${loginUrl}wechat/jsSdkConfig`, config)
    },
    jsSdkConfig2 (config) {
      return axios.get(`wechat/getWxJsConfig`, config)
    }
  },
  public: {
    loadCategoryFilter (query, config) {
      return axios.post(
        `${loginUrl}public/loadCategoryFilter`,
        qs.stringify(query),
        config
      )
    }
  },
  gfChooseRegister: {
    gfChooseRegister (config) {
      return axios.get(`${loginUrl}member/gfChooseRegister`, config)
    },
    saveOrUpdate (config) {
      return axios.post(`${loginUrl}member/gfChooseRegister/saveOrUpdate`, config)
    },
    surplusModifyTimes (config) {
      return axios.get(`${loginUrl}member/gfChooseRegister/surplusModifyTimes`, config)
    }
  },
  lubo: {
    login (query) {
      return axios.get(`${loginUrl}student/special/useCard?${qs.stringify(query)}`)
    },
    getEmail (query) {
      return axios.get(`${loginUrl}student/special/receive?${qs.stringify(query)}`)
    },
    goRegister (query) {
      return axios.get(`${loginUrl}student/special/usePhone?${qs.stringify(query)}`)
    },
    getTime (query) {
      return axios.get(`${loginUrl}student/special/watch?${qs.stringify(query)}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js